import { managementApis } from '../../static/ApiData';
export default async (name, method) => {
  const filteredManagementApis = managementApis.filter(
    (api) => api.name === name && api.method === method
  )?.[0]?.snippets;
  return {
    apis: filteredManagementApis,
  };
};
